/*eslint-disable no-undef,no-redeclare,no-empty,no-unused-vars */
import April from '../../ALizard/April'

export default ()=>{
    April.define("input.select-skill", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
        }else if(args.opr == 'back'){
        }else if(args.opr == 'play'){
            var scene=args.scene;
            scene.flare("act_console",{ value: "call SkillComponent/input.select-skill-request" });
        }
    });
    
    April.define("input.select-target", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
        }else if(args.opr == 'back'){
        }else if(args.opr == 'play'){
            var scene=args.scene;
            scene.flare("act_console",{ value: "call SkillComponent/input.select-single-target-request" });
        }
    });    

    April.define("log.dice", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
        }else if(args.opr == 'back'){
        }else if(args.opr == 'play'){
            var scene=args.scene;
            scene.flare("act_console",{ value: "call log.dice" });
        }
    });    
}
